import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject, Injector, runInInjectionContext } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';

import { isApiError } from '@lentau/core/api/application';
import { sendErrorAnalyticByRoute } from '../analytic/error-analytic';

export const requestErrorAnalyticInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const injector = inject(Injector);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleApiError = (httpEvent: HttpEvent<any> | HttpErrorResponse) => {
    /**
     *  Проверяем по полям объекта есть ли там ошибка
     */
    try {
      if (isApiError(httpEvent)) {
        void runInInjectionContext(injector, () => sendErrorAnalyticByRoute(httpEvent, injector));
      }
    } catch (error) {
      console.error(error);
    }
  };

  /**
   *  вызывается в обоих местах, потому что ошибка может приходить со статусом 200.
   *  если кинуть тут ошибку, то {@link FailureInterceptor} не сможет ее поймать
   */
  return next(req).pipe(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tap((event: HttpEvent<any>) => handleApiError(event)),
    catchError((error: HttpErrorResponse) => {
      handleApiError(error);
      return throwError(() => error);
    })
  );
};
